import { MDBCheckbox, MDBInput } from "mdb-react-ui-kit";
import { useCallback, useMemo } from "react";
import { CustomSelect } from "../../../CustomSelect";
import { ASParamEditorProps } from "../ASParamEditor";

export const ASColorParam = ({currentValue, disabled, param, onCurrentValueChange}: ASParamEditorProps<number>) => {

    const colors = useMemo(() => Object.keys(param.colors ?? {}).map(title => ({
        title,
        val: (param.colors ?? {})[title] ?? 0
    })), [param]);

    return (
        <CustomSelect
            items={colors.map(({title, val}) => ({
                val,
                title: `#${val} - ${title}`
            }))}
            defaultTitle="No data"
            selected={currentValue}
            disabled={disabled}
            onSelect={c => onCurrentValueChange(Number(c))}
            width={300}
        />
    )
    
}
